import * as React from "react";
import { observer, inject } from "mobx-react";
import { action, observable } from "mobx";
import SeekerStore from "../../stores/seekerStore";
import HudsonYardsStore from "../../stores/hudsonYardsStore";
import BackButton from "../../components/widgets/backBtn";
import { Grid, Row, Col } from "react-flexbox-grid";
import TextField from "material-ui/TextField";
import { FormControlLabel } from "material-ui/Form";
import Input, { InputLabel} from "material-ui/Input";
import Button from "material-ui/Button";
import Busy from "../../components/widgets/busy";
import * as s from "./hudsonYards.css";
import { BusyEvent, LookupType } from "../../models/enums";
import UserInfo from "../../models/client/hudsonyards/userInfo";
import  Radio, { RadioGroup} from 'material-ui/Radio';


@inject("store") @observer
export default class HyApplicationVw extends React.Component<{ store: SeekerStore }, {}> {
  private _hyStore: HudsonYardsStore;
  constructor(props: any) {
    super(props);
    this._hyStore = this.props.store.hyStore;
  }

  componentWillMount() {
    this._hyStore.getUserInfo(this._hyStore.initApplication);
  }

  componentWillUnmount() {
    this._hyStore.resetForm();
  }

  render() {
    const selected: any = { color: "#5B6770" };
    const editUser: UserInfo = this._hyStore.editUserInfo;
    return <div>
      <BackButton />
      <Busy show={this.props.store.viewState.isBusy(BusyEvent.LoadProfile)} size="lg" center={true} msg="One moment while we retrieve your profile" />
      {!this.props.store.viewState.isBusy(BusyEvent.LoadProfile) && <Grid className={s.container}>
        <Row>
          <Col xs={12}>
            <h4 className={s.blueHeader}>Hudson Yards Assistance Survey</h4>
            <h6 className={s.disclaimer}>The information provided will be used to help assist you with additional services and training</h6>
          </Col>
        </Row>
        <Row>
          <Col xs={12} sm={5}><TextField error={editUser.firstName.length === 0 && this._hyStore.validated} fullWidth id="firstName" label="First Name" value={editUser.firstName} onChange={(e: any) => this._hyStore.handleChange(e)} /></Col>
          <Col xs={12} sm={5}><TextField error={editUser.lastName.length === 0 && this._hyStore.validated} fullWidth id="lastName" label="Last Name" value={editUser.lastName} onChange={(e: any) => this._hyStore.handleChange(e)} /></Col>
          <Col xs={12} sm={2}><TextField fullWidth id="submitted" disabled={true} label="Date" value={editUser.submitted.toDateString()} /></Col>
        </Row>
        <br />
        <Row>
          <Col xs={12} sm={8}><TextField fullWidth id="street1" error={editUser.address.street1.length === 0 && this._hyStore.validated && !editUser.homeless} label="Street 1" value={editUser.address.street1} onChange={(e: any) => this._hyStore.handleAddressChange(e)} /></Col>
          <Col xs={12} sm={4}><TextField fullWidth id="city" error={editUser.address.city.length === 0 && this._hyStore.validated && !editUser.homeless} label="City" value={editUser.address.city} onChange={(e: any) => this._hyStore.handleAddressChange(e)} /></Col>
          <Col xs={12} sm={8}><TextField fullWidth id="street2" label="Street 2" value={editUser.address.street2} onChange={(e: any) => this._hyStore.handleAddressChange(e)} /></Col>
          <Col xs={6} sm={2}><TextField fullWidth id="state" error={editUser.address.state.length === 0 && this._hyStore.validated && !editUser.homeless} label="State" value={editUser.address.state} onChange={(e: any) => this._hyStore.handleAddressChange(e)} /></Col>
          <Col xs={6} sm={2}><TextField fullWidth id="zip" error={editUser.address.zip.length < 5 && this._hyStore.validated && !editUser.homeless} label="Zip" value={editUser.address.zip} onChange={(e: any) => this._hyStore.handleAddressChange(e)} /></Col>
        </Row>
        <br />
        <Row>
          <Col xs={12} sm={6}><TextField fullWidth id="email" error={editUser.email.length === 0 && this._hyStore.validated} label="Email Address" value={editUser.email} onChange={(e: any) => this._hyStore.handleChange(e)} /></Col>
          <Col xs={12} sm={6}><TextField fullWidth id="phone" error={editUser.phone.length === 0 && this._hyStore.validated} label="Phone Number" value={editUser.phone} onChange={(e: any) => this._hyStore.handleChange(e)} /></Col>
        </Row>
        <br />
        <Row>
          <Col xs={12} className={s.radioGroup}>
            <p className={s.question}>Are you a veteran?</p>
            <RadioGroup
              aria-label="veteran"
              name="veteran"
              style={{ display: "inline-block" }}
              value={editUser.veteran ? "true" : "false"}
              onChange={(e, v) => this._hyStore.handleSelectChange(e, v === "true")}
            >
              <FormControlLabel value="true" control={<Radio style={selected} />} label="Yes" />
              <FormControlLabel value="false" control={<Radio style={selected} />} label="No" />
            </RadioGroup>
          </Col>
        </Row>
        <br />
        <Row>
          <Col xs={12} className={s.radioGroup}>
            <p className={s.question}>Are you homeless?</p>
            <RadioGroup
              aria-label="homeless"
              name="homeless"
              style={{ display: "inline-block" }}
              value={editUser.homeless ? "true" : "false"}
              onChange={(e, v) => this._hyStore.handleSelectChange(e, v === "true")}
            >
              <FormControlLabel value="true" control={<Radio style={selected} />} label="Yes" />
              <FormControlLabel value="false" control={<Radio style={selected} />} label="No" />
            </RadioGroup>
          </Col>
        </Row>
        <br />
        <Row>
          <Col xs={12} className={s.radioGroup}>
            <p className={s.question}>Are you a resident of NYCHA?</p>
            <RadioGroup
              aria-label="residentNYCHA"
              name="residentNYCHA"
              style={{ display: "inline-block" }}
              value={editUser.residentNYCHA ? "true" : "false"}
              onChange={(e, v) => this._hyStore.handleSelectChange(e, v === "true")}
            >
              <FormControlLabel value="true" control={<Radio style={selected} />} label="Yes" />
              <FormControlLabel value="false" control={<Radio style={selected} />} label="No" />
            </RadioGroup>
          </Col>
        </Row>
        {editUser.residentNYCHA && <Row>
          <Col xs={12}><p className={s.question}>If yes, where do you reside within NYCHA?</p></Col>
          <Col xs={12} sm={6}><TextField error={editUser.residentNYCHA && editUser.residentLocation.length === 0 && this._hyStore.validated} fullWidth id="residentLocation" label="Enter location" value={editUser.residentLocation} onChange={(e: any) => this._hyStore.handleChange(e)} /></Col>
        </Row>}
        <br />
        <Row>
          <Col xs={12} className={s.radioGroup}>
            <p className={s.question}>Were you incarcerated previously?</p>
            <RadioGroup
              aria-label="exOffender"
              name="exOffender"
              style={{ display: "inline-block" }}
              value={editUser.exOffender ? "true" : "false"}
              onChange={(e, v) => this._hyStore.handleSelectChange(e, v === "true")}
            >
              <FormControlLabel value="true" control={<Radio style={selected} />} label="Yes" />
              <FormControlLabel value="false" control={<Radio style={selected} />} label="No" />
            </RadioGroup>
          </Col>
        </Row>
        <br />
        <Row>
          <Col xs={12} className={s.radioGroup}>
            <p className={s.question}>Are you a person with a disability?</p>
            <RadioGroup
              aria-label="disabled"
              name="disabled"
              style={{ display: "inline-block" }}
              value={editUser.disabled ? "true" : "false"}
              onChange={(e, v) => this._hyStore.handleSelectChange(e, v === "true")}
            >
              <FormControlLabel value="true" control={<Radio style={selected} />} label="Yes" />
              <FormControlLabel value="false" control={<Radio style={selected} />} label="No" />
            </RadioGroup>
          </Col>
        </Row>
        <br />
        <br />
        <Row>
          <Col xs={12}>
            {this._hyStore.showValidationMsg && <h4 className={s.validationMsgText}>Please complete the form before submitting.</h4>}
            {this._hyStore.submitted && <h4 className={s.blueHeader}>Thank you, your form has been submitted.</h4>}
            <Button raised size="large" color="secondary" onClick={() => this._hyStore.saveUserInfo()}>Sign & Submit</Button></Col>
        </Row>
        <br />
      </Grid>}     
      </div>
    }
}


// WEBPACK FOOTER //
// ./src/views/hyApplication/index.tsx